// components/CustomMiniDialog.tsx
import React, { ChangeEvent } from "react";
import { Box, Typography } from "@mui/material"; // Adjust the import path as necessary
import { MiniDialog } from "./MiniDialog";
import { CustomMultiLineInput } from "../Input/CustomMultiLineInput";

interface CustomMiniDialogProps {
  color: string;
  open: boolean;
  title: string;
  note: string;
  question?: string;
  reasonInstructions?: string;
  isReasonOptional?: boolean;
  isLoading?: boolean;
  fetchType: "Issue" | "Rejection" | "Cancel" | "Approval";
  onClose: () => void;
  onConfirm: () => void;
  onNoteChange: (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
};

export const DialogConfirmation: React.FC<CustomMiniDialogProps> = ({
  color,
  open,
  title,
  note,
  question,
  reasonInstructions,
  onClose,
  onConfirm,
  onNoteChange,
  isReasonOptional,
  isLoading = false,
  fetchType,
}) => {
  return (
    <MiniDialog
      color={color}
      handleClose={onClose}
      open={open}
      title={title}
      onConfirm={onConfirm}
      isLoading={isLoading}
    >
      <Typography variant="body1" gutterBottom>
        {question}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        {reasonInstructions}
      </Typography>
      <Box mt={3}>
        <CustomMultiLineInput
          label={
            isReasonOptional
              ? `${fetchType} Reason (optional)`
              : `${fetchType} Reason`
          }
          placeholder="Add your reason here..."
          name="remark"
          value={note}
          onChange={onNoteChange}
        />
      </Box>
    </MiniDialog>
  );
};
